<div class="container-fluid bg-white">
    <header class="row d-flex align-items-center">
        <div class="col-xl-3 col-12" [ngClass.sm]="'pt-1'" [ngClass.md]="'pt-1'">
            <img src="../assets/images/logo/nepta.svg" alt="brand-logo" height="28"/>
        </div>
        <div class="col-xl-9 col-12 px-xl-0">
            <app-onboarding-header></app-onboarding-header>
        </div>
    </header>
    <div class="row" id="main-container">
        <div class="col-md-9 col-12 offset-md-3 pt-2 position-relative">
            <div class="row">
                <div class="col-lg-6 col-md-6 col-12">
                    <h1>{{"SKILLS" | translate}} / {{"COMPETENCE" | translate}}</h1>
                    <small>{{'INSERT.SKILLS' | translate}}</small>
                </div>
                <div class="col-lg-6 col-md-6 col-12 text-lg-right text-md-right text-left">
                    <span (click)="showVideo()" [ngbTooltip]="'SHOW_TUTORIAL'|translate" placement="top" class="cursor-pointer text-primary">{{'DONT_KNOW_HOW_TO_DO'|translate}}</span>
                </div>
            </div>
            <div class="row align-items-center py-2 pr-md-2 border-bottom" *ngFor="let item of items_skills; let i = index">
                <div class="form-group col-md-6 col-lg-4 col-12" [ngbTooltip]="(skillNotDeletable && skillNotDeletable.includes(item.skill)) && item.enabled !== -1 ? ('SKILL_FROM_EXPERIENCE' | translate) : null">
                    <label [for]="'skill_'+i">{{"SKILLS" | translate}}<sup class="text-danger">*</sup></label>
                    <ng-select [id]="'skill_'+ i" bindLabel="name" bindValue="id" [closeOnSelect]="true" [clearable]="false" [openOnEnter]="false" (change)="checkIfAlreadyInsertedSkill($event, i)"
                               [virtualScroll]="true" [disabled]="skillNotDeletable && skillNotDeletable.includes(item.skill)" [items]="_skillService.list_enabled" [(ngModel)]="item.skill" *ngIf="!item.isNew && (item.enabled === 1 || !item.enabled)">
                    </ng-select>
                    <ng-select [id]="'skill_'+ i" bindLabel="name" bindValue="id" [closeOnSelect]="true" [clearable]="false"
                               [openOnEnter]="false" [virtualScroll]="true" *ngIf="item.enabled === -1"
                               [(ngModel)]="item.skill" [items]="_skillService.list" [readonly]="true"
                               [ngbTooltip]="'TO_APPROVED' | translate">
                    </ng-select>
                    <input type="text" class="form-control" [value]="item.skill" *ngIf="item.isNew" readonly>
                </div>
                <div class="form-group col-12 col-md-6 col-lg-4">
                    <label [for]="'level_'+i">{{"SENIORITY" | translate}}<sup class="text-danger">*</sup></label>
                    <ng-select [id]="'level_'+ i" [closeOnSelect]="true" [clearable]="false" [openOnEnter]="false"
                               [virtualScroll]="true" [(ngModel)]="item.level">
                        <ng-option value=junior>{{"JUNIOR" | translate}}</ng-option>
                        <ng-option value='middle'>{{"MIDDLE" | translate}}</ng-option>
                        <ng-option value='senior'>{{"SENIOR" | translate}}</ng-option>
                    </ng-select>
                </div>
                <div class="col-12 col-md-6 col-lg-3">
                    <div class="custom-control custom-control-success custom-switch mb-0" [ngClass.sm]="'d-flex mb-1'">
                        <span [ngClass.xl]="'mr-2'" [ngClass.md]="'mr-2'" [ngClass.sm]="'mr-025'">{{'SET_AS_PRIMARY_SKILL' | translate}}</span>
                        <input type="checkbox" checked class="custom-control-input" (change)="onSetPrimarySkill(item, i)" [disabled]="item.level === '' || item.skill < 1" [id]="'skill_primary_'+i" [(ngModel)]="item.primary"/>
                        <label class="custom-control-label" [for]="'skill_primary_'+i"></label>
                    </div>
                </div>
                <!-----------------------------------------------------Buttons------------------------------------------>
                <div class="col-md-6 col-lg-1 col-12 d-flex align-items-center" [ngClass.xl]="'justify-content-end'" [ngClass.md]="'justify-content-end'" *ngIf="items_skills.length > 0">
                    <button (click)="addItem()" type="button" class="btn btn-success btn-circle btn-sm mr-1" rippleEffect>
                        <i class="fa fa-plus"></i>
                    </button>
                    <button (click)="deleteItem(i)" [disabled]="(skillNotDeletable && skillNotDeletable.includes(item.skill)) || item.enabled === -1" type="button" class="btn btn-danger btn-circle btn-sm" rippleEffect *ngIf="items_skills.length > 1">
                        <i class="fa fa-minus"></i>
                    </button>
                </div>
                <div class="form-group col-12" *ngIf="item.skill === ''">
                    <p class="sugges-new-item m-0" [ngClass.sm]="'mt-1'" (click)="modalOpen(modalBasic, i)">{{"MODAL.NOT_SKILL" | translate}}</p>
                </div>
            </div>
            <div class="row pr-md-2 pt-2">
                <div class="col-12 d-flex justify-content-end mb-4" *ngIf="items_skills.length > 0">
                    <button (click)="save()" type="submit" class="btn btn-primary">{{"NEXT" | translate}}</button>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Modal -->
<ng-template #modalBasic let-modal>
    <div class="modal-header">
        <div></div>
        <button type="button" class="close" (click)="modal.dismiss('Cross click')"
                aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" tabindex="0">
        <h3>{{"MODAL.NOT_SKILL" | translate}}</h3>
        <p>{{"MODAL.INSERT_HERE" | translate}}</p>
        <label [for]="'new_skill'">{{'SKILLS' | translate}}<sup class="text-danger">*</sup></label>
        <input [(ngModel)]="new_skill" type="text" [id]="'new_skill'" class="form-control"/>
    </div>
    <div class="modal-footer d-flex justify-content-center">
        <button type="submit" class="btn btn-primary w-150"
                (click)="addModalObject(); modal.close('Accept click')"
                rippleEffect>
            {{"SEND" | translate}}
        </button>
    </div>
</ng-template>
<!-- / Modal -->